<template>
  <section v-if="vm.isMobile" class="free-time-section">
    <FreeTimeMobile />
    <FreeTimeSavingMobile v-if="lang !== 'zh'" />
  </section>
  <FreeTimeForeignPC v-else />
</template>
<script>
import FreeTimeForeignPC from './FreeTimeForeignPC';
import FreeTimeMobile from './FreeTimeMobile';
import FreeTimeSavingMobile from './FreeTimeSavingMobile';

export default {
  inject: ['vm', 'lang'],
  components: {
    FreeTimeForeignPC,
    FreeTimeMobile,
    FreeTimeSavingMobile
  },
  data() {
    return {
      width: window.innerWidth
    };
  },
  mounted() {
    window.addEventListener('resize', () => {
      this.width = window.innerWidth;
    });
  }
};
</script>
